import React, { useState, useEffect } from 'react';
import { FaDownload, FaTrash } from "react-icons/fa";
import ConfirmModal from '../utils/ConfirmModal';
import InformModal from '../utils/InformModal';
import ImageUploader from '../utils/ImageUploader';
import IconPicker from './IconPicker';
import { useAuth } from '../../contexts/AppContext';
import IconLibraryPicker from '../utils/IconLibraryPicker';
import { Button, Switch } from 'antd';

const TsNonLeafNode = ({
  detail,
  setDetail,
  saveContent,
  handleImageDelete,
  ownerId,
  ownerType = "adv",
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [switchState, setSwitchState] = useState(detail.isLeaf);
  const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);
  const { token, selectedRole } = useAuth();
  const id = selectedRole?.id || '';
  const [iconPickerOpen, setIconPickerOpen] = useState(false);

  // 首次进入时展示一次的显示模式提示
  const [showDisplayModeHint, setShowDisplayModeHint] = useState(false);
  useEffect(() => {
    if (!localStorage.getItem('hasSeenDisplayModeHint')) {
      setShowDisplayModeHint(true);
    }
  }, []);
  const handleCloseHint = () => {
    setShowDisplayModeHint(false);
    localStorage.setItem('hasSeenDisplayModeHint', 'true');
  };

  const handleSwitch = () => {
    if (detail.attributes && detail.attributes.length > 0) {
      setIsErrorModalOpen(true);
    } else {
      setIsModalOpen(true);
    }
  };

  const confirmSwitch = () => {
    setIsModalOpen(false);
    setSwitchState(!switchState);
    setDetail((prevDetail) => ({
      ...prevDetail,
      isLeaf: true, description: '', bannerImage: '',
      imageUrls: [], leftDescription: '', rightDescription: '',
    }));
  };

  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-7xl w-[90%] mx-auto">
        {/* 鍒囨崲鎸夐挳 */}
        <div className="flex justify-end my-6">
          <button
            onClick={handleSwitch}
            className="px-4 py-1 text-base bg-white border border-red-200 text-red-500 hover:bg-red-50 shadow-sm transition rounded-lg"
          >
            Convert to Entry
          </button>
        </div>
        <ConfirmModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          onConfirm={confirmSwitch}
          header="Switch to Entry"
          content="Switching will clear all data and change this directory to a content entry."
        />
        <InformModal
          isOpen={isErrorModalOpen}
          onClose={() => { setIsErrorModalOpen(false); }}
          content="Please remove all entries inside this directory before switching to Entry mode."
          type='alert'
        />

        {/* --------- Directory information --------- */}
        <div className="mb-7 pb-2 border-b border-gray-200">
          <div className="text-2xl font-bold text-gray-800 mb-6">Directory Information</div>
          <label className='block mt-2 mb-6'>
            <span className="block text-lg font-semibold text-gray-700">
              Name
              <span className='text-xs text-gray-400'>
                &nbsp;{detail.name ? detail.name.length : 0}/30
              </span>
            </span>
            <input
              type="text"
              name="name"
              value={detail.name || ''}
              onChange={(e) =>
                setDetail({ ...detail, name: e.target.value })
              }
              maxLength={30}
              disabled={detail.name?.includes('(Shared)')}
              className={`mt-2 block w-full h-11 rounded border shadow-sm px-3 text-base
      ${detail.name?.includes('(Shared)')
                  ? 'bg-gray-200 text-gray-500 border-gray-300 cursor-not-allowed'
                  : 'bg-gray-50 text-gray-900 border-gray-300'}`}
            />
          </label>

          <div className="mb-6 rounded-xl border border-gray-200 bg-gray-50 px-4 py-4">
            <div className="flex items-center justify-between gap-4">
              <div>
                <div className="text-lg font-semibold text-gray-800">Shuffle non-pinned items</div>
                <div className="text-sm text-gray-500">
                  Pinned child entries stay at the top. All other child entries will be randomly ordered on the touchscreen.
                </div>
              </div>
              <Switch
                checked={!!detail.shuffleChildren}
                onChange={(checked) => setDetail((prevDetail) => ({ ...prevDetail, shuffleChildren: checked }))}
              />
            </div>
          </div>
          {/* --------- Initial display mode hint --------- */}
          {showDisplayModeHint && (
            <div className="mb-6 p-4 rounded-xl bg-blue-50 border border-blue-200 shadow flex items-center justify-between">
              <div>
                <div className="font-semibold text-blue-800 mb-1">How to choose display mode?</div>
                <div className="text-gray-700 text-sm">
                  <b>Sidebar:</b> Image on the left, title and short description on the right.<br />
                  <b>Overlay:</b> Large image with title, perfect for visual content or gallery style.
                </div>
              </div>
              <button
                onClick={handleCloseHint}
                className="ml-4 px-4 py-1 rounded bg-blue-500 text-white hover:bg-blue-600 transition"
              >
                Got it
              </button>
            </div>
          )}

          {/* --------- 鍙屽崱鐗囨ā寮忛€夋嫨 --------- */}
          <div className="block text-lg font-semibold text-gray-700 mb-2">Display Mode</div>
          <div className="flex gap-6">
            {/* Sidebar Card */}
            <button
              type="button"
              onClick={() => setDetail({ ...detail, layoutStyle: 'sidebar' })}
              className={`
                flex-1 rounded-xl border-2 p-6 shadow-sm transition
                flex flex-col items-center text-center
                ${detail.layoutStyle === 'sidebar'
                  ? 'border-blue-500 bg-blue-50 ring-2 ring-blue-200'
                  : 'border-gray-200 bg-gray-50 hover:border-blue-400'}
              `}
            >
              <div className="w-12 h-12 rounded bg-blue-400 mb-2 flex items-center justify-center">
                <svg width="32" height="32">
                  <rect x="2" y="7" width="10" height="18" rx="2" fill="#3b82f6" />
                  <rect x="15" y="10" width="14" height="4" rx="2" fill="#60a5fa" />
                  <rect x="15" y="18" width="10" height="4" rx="2" fill="#60a5fa" />
                </svg>
              </div>
              <div className="font-bold text-blue-700 mb-1">Sidebar</div>
              <div className="text-gray-600 text-sm">
                Image on the left, title and summary on the right.<br />
                <span className="text-gray-400 text-xs">Best for list pages with pictures and text.</span>
              </div>
            </button>
            {/* Overlay Card */}
            <button
              type="button"
              onClick={() => setDetail({ ...detail, layoutStyle: 'overlay' })}
              className={`
                flex-1 rounded-xl border-2 p-6 shadow-sm transition
                flex flex-col items-center text-center
                ${detail.layoutStyle === 'overlay'
                  ? 'border-purple-500 bg-purple-50 ring-2 ring-purple-200'
                  : 'border-gray-200 bg-gray-50 hover:border-purple-400'}
              `}
            >
              <div className="w-12 h-12 rounded bg-purple-400 mb-2 flex items-center justify-center">
                <svg width="32" height="32">
                  <rect x="3" y="7" width="26" height="16" rx="3" fill="#a78bfa" />
                  <rect x="9" y="24" width="14" height="4" rx="2" fill="#ddd6fe" />
                </svg>
              </div>
              <div className="font-bold text-purple-700 mb-1">Overlay</div>
              <div className="text-gray-600 text-sm">
                Large image with prominent title.<br />
                <span className="text-gray-400 text-xs">Best for featured or visual content.</span>
              </div>
            </button>
            {/* Recommend Card */}
            <button
              type="button"
              onClick={() => setDetail({ ...detail, layoutStyle: 'recommend' })}
              className={`
                flex-1 rounded-xl border-2 p-6 shadow-sm transition
                flex flex-col items-center text-center
                ${detail.layoutStyle === 'recommend'
                  ? 'border-green-500 bg-green-50 ring-2 ring-green-200'
                  : 'border-gray-200 bg-gray-50 hover:border-green-400'}
              `}
            >
              <div className="w-12 h-12 rounded bg-green-400 mb-2 flex items-center justify-center">
                <svg width="32" height="32">
                  <circle cx="16" cy="12" r="6" fill="#34d399" />
                  <path d="M6 27c1-6 6-9 10-9s9 3 10 9" fill="#a7f3d0" />
                </svg>
              </div>
              <div className="font-bold text-green-700 mb-1">Recommend</div>
              <div className="text-gray-600 text-sm">
                Interest + time picker that suggests places to visit.<br />
                <span className="text-gray-400 text-xs">Best for a "Plan Your Visit" style entry point.</span>
              </div>
            </button>
          </div>
        </div>
        <div className="mb-7 pb-2 border-b border-gray-200"></div>

        <div className="mb-7 pb-2 border-b border-gray-200">
          <div className="text-2xl font-bold text-gray-800 mb-4">Display Icon</div>
          <IconPicker
            value={detail.iconImage || null}
            onChange={(url) => {
              if (!url) {
                setDetail(prev => ({ ...prev, iconImage: '', brandImagePrivate: '' }));
                return;
              }

              const file = url.split('/').pop() || '';
              setDetail(prev => ({
                ...prev,
                iconImage: url,
                brandImagePrivate: file,
              }));
            }}
            className="mt-2"
          />
        </div>

        {/* --------- Images --------- */}
        {/* Keep prefix / thumbPrefix behavior consistent */}
        {detail.isNoParent ? (
          <div>
            <div className="mb-2">
              <div className="text-2xl font-bold text-gray-800 mb-4">Banner Icon</div>

              <div className="flex gap-4 items-center">
                <Button onClick={() => setIconPickerOpen(true)}>Choose Icon</Button>

                {detail.bannerImage && (
                  <img
                    src={detail.bannerImage}
                    alt="icon"
                    className="w-20 h-20 object-contain bg-gray-200 rounded p-2 border"
                  />
                )}
              </div>

              <IconLibraryPicker
                open={iconPickerOpen}
                onClose={() => setIconPickerOpen(false)}
                isIconLibrary={true}
                bucket="touchscreen-cms"    // icon bucket name
                prefix="icons/"             // open directly inside the icons folder
                onSelect={(url) => {
                  setDetail(prev => ({ ...prev, bannerImage: url }));
                }}
                token={token}
              />
            </div>
          </div>
        ) : (
          <div className="mb-2">
            <div className="text-2xl font-bold text-gray-800 mb-4">Banner Image</div>

            {/* 浣跨敤 MediaTab 涓€鏍风殑鏂扮増 ImageUploader */}
            <ImageUploader
              token={token}
              prefix={selectedRole?.S3Id ? `full/${selectedRole.S3Id}/` : undefined}
              thumbPrefix={selectedRole?.S3Id ? `thumb/${selectedRole.S3Id}/` : undefined}
              ownerType={ownerType}
              ownerId={id}
              width={1080}
              height={340}
              objectFit="cover"
              value={detail.bannerImage}
              onChange={(url) =>
                setDetail((prev) => ({
                  ...prev,
                  bannerImage: url,
                }))
              }
            />

            {detail.bannerImage && (
              <div className="mt-4 relative group">
                <img
                  src={detail.bannerImage}
                  alt="sideImage"
                  className="w-full aspect-video object-cover rounded-lg shadow-sm border"
                />

                <a
                  href={detail.bannerImage}
                  download="bannerImage.jpg"
                  className="absolute top-2 left-2 bg-white/80 hover:bg-blue-200 p-2 rounded-full shadow"
                  title="Download"
                >
                  <FaDownload className="text-blue-500" />
                </a>

                <button
                  className="absolute top-2 right-2 bg-white/80 hover:bg-red-100 p-2 rounded-full shadow"
                  onClick={() => handleImageDelete("bannerImage")}
                  title="Delete"
                  type="button"
                >
                  <FaTrash className="text-red-500" />
                </button>
              </div>
            )}
          </div>
        )}

      </div>
    </div>
  );
};

export default TsNonLeafNode;

